<template>
  <v-container :fluid="true" class="ma-0 pa-0 bg-light-blue">
    <Promocodes
        v-if="$route.name === names.PROMO.PAGE"
    />
    <router-view v-else />
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import Promocodes from "@/modules/personal_account/promocodes/pages/Promocodes.vue"
import names from "@/modules/personal_account/routers/names"

export default defineComponent({
  name: "PromocodesBase",
  computed: {
    names () {
      return names
    }
  },
  components: { Promocodes }
})
</script>

<style scoped lang="scss">

</style>
